import { useApiMutations } from "@/queries/base/useApiMutations";

/**
 * Mutation for importing SOT from file.
 * POST /v2/service_order_ticket/import
 */
export function useSotImportMutation() {
  const { post, isLoading } = useApiMutations("/v2/service_order_ticket");
  return {
    isLoading,
    import: (payload, opts) =>
      post("/import", payload, { ...opts, isFormData: true }),
  };
}
